import styled from "styled-components";

const EditContainer = styled.div`
  overflow: "auto";
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 20px;
`;

export { EditContainer, HeaderContainer };
